var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { RouterLink } from "../../Link";
import { minWidthMedia } from "../../global/media";
export var Nav = styled.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: none;\n  max-width: 100%;\n  margin-top: ", ";\n  ", "\n"], ["\n  border: none;\n  max-width: 100%;\n  margin-top: ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
}, minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-right: 1px solid ", ";\n    padding-right: ", ";\n    max-width: 330px;\n  "], ["\n    border-right: 1px solid ", ";\n    padding-right: ", ";\n    max-width: 330px;\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.highlight;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.four;
}));
export var Ul = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
export var MenuListItem = styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  list-style-type: none;\n\n  ", "\n"], ["\n  list-style-type: none;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, isCategory = _a.isCategory;
    return isCategory && "\n    :not(:first-of-type) {\n      padding-top: " + theme.spacing.four + ";\n    }\n  ";
});
export var MenuItemLink = styled(RouterLink)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: ", ";\n  text-decoration: none;\n  color: ", ";\n  border-radius: 5px;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    ", "\n    text-decoration: none;\n  }\n  &:active {\n    ", "\n    font-family: ", ";\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: ", ";\n  text-decoration: none;\n  color: ", ";\n  border-radius: 5px;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    ", "\n    text-decoration: none;\n  }\n  &:active {\n    ", "\n    font-family: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, isCategory = _a.isCategory;
    return isCategory ? "0 0 " + theme.spacing.one : "" + theme.spacing.one;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.fontColor;
}, function (_a) {
    var isCategory = _a.isCategory, theme = _a.theme;
    return isCategory && "\n    font-family: " + theme.font.semibold + ";\n    font-size: 16px;\n    color: " + theme.colors.utility.ink + ";\n  ";
}, function (_a) {
    var isCurrent = _a.isCurrent, isCategory = _a.isCategory, theme = _a.theme;
    return isCurrent && !isCategory && "\n    font-family: " + theme.font.semibold + ";\n    color: " + theme.colors.primary1 + ";\n  ";
}, function (_a) {
    var theme = _a.theme, isCategory = _a.isCategory;
    return theme.mediaQueries.maxWidthMedia.tablet(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), !isCategory ? theme.spacing.two : theme.spacing.two + " 0 " + theme.spacing.one + " " + theme.spacing.one);
}, function (_a) {
    var isCurrent = _a.isCurrent, isCategory = _a.isCategory, theme = _a.theme;
    return (isCurrent && !isCategory) ? theme.colors.primary1 : theme.colors.utility.ink;
}, function (_a) {
    var isCategory = _a.isCategory, theme = _a.theme;
    return !isCategory && "background-color: " + theme.colors.utility.highlight + ";";
}, function (_a) {
    var theme = _a.theme, isCategory = _a.isCategory;
    return !isCategory && "color: " + theme.colors.primary1 + ";";
}, function (_a) {
    var theme = _a.theme;
    return theme.font.semibold;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
